// Derives a human-readable "source" for a booking trigger from the DOM, so
// every content section is captured automatically without per-button config.
// Priority: an explicit [data-booking-source] override, then the nearest
// section's heading, then a landmark, then "page".
export function getBookingSource(el: Element | null | undefined): string {
  if (!el || typeof document === "undefined") return "page";

  const override = el.closest("[data-booking-source]");
  if (override) {
    return override.getAttribute("data-booking-source")?.trim() || "page";
  }

  const section = el.closest("section, article, [data-section]");
  if (section) {
    const named = section.getAttribute("data-section")?.trim();
    if (named) return named;
    const heading = section.querySelector("h1, h2, h3");
    const text = heading?.textContent?.replace(/\s+/g, " ").trim();
    if (text) return text.slice(0, 80);
  }

  const landmark = el.closest("nav, header, footer");
  if (landmark) {
    return landmark.getAttribute("aria-label") || landmark.tagName.toLowerCase();
  }

  // Section-less modules (e.g. link/explainer buttons, some heroes) still
  // produce a useful value from the trigger's own label.
  const trigger = el.closest("a, button");
  const label = (trigger?.getAttribute("aria-label") || trigger?.textContent || "")
    .replace(/\s+/g, " ")
    .trim();
  if (label) return label.slice(0, 80);

  return "page";
}
